<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="`${$t('anyform.name')} (EN)`">
              <b-form-input type="text" v-model="$v.createForm.name_en.$model" :state="!$v.createForm.name_en.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.name_en.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('anyform.name')} (RU)`">
              <b-form-input type="text" v-model="$v.createForm.name_ru.$model" :state="!$v.createForm.name_ru.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.name_ru.required">
                {{ $t('formErrors.enterName') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.promocodes.startDate')" class="mb-3">
              <datepicker :bootstrap-styling="true" v-model="$v.createForm.start.$model"></datepicker>
              <div
                :class="{
                  'invalid-feedback': true,
                  'd-block': $v.createForm.start.$error && !$v.createForm.start.required
                }"
              >
                {{ $t('formErrors.enterStartDate') }}
              </div>
            </b-form-group>

            <b-form-group :label="$t('pages.promocodes.endDate')" class="mb-3">
              <datepicker :bootstrap-styling="true" v-model="$v.createForm.end.$model"></datepicker>
              <div
                :class="{
                  'invalid-feedback': true,
                  'd-block': $v.createForm.end.$error && !$v.createForm.end.required
                }"
              >
                {{ $t('formErrors.enterEndDate') }}
              </div>
            </b-form-group>

            <b-form-group :label="$t('pages.promocodes.code')">
              <b-form-input type="text" v-model="$v.createForm.code.$model" :state="!$v.createForm.code.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.code.required">
                {{ $t('formErrors.enterCode') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.promocodes.sale')">
              <b-form-input type="text" v-model="$v.createForm.sale.$model" :state="!$v.createForm.sale.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.sale.required">
                {{ $t('formErrors.enterSale') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.createForm.sale.numeric">
                {{ $t('formErrors.mustBeNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Which is active?">
              <v-select v-model="active" :options="activeOptions" />
            </b-form-group>

            <b-form-group v-if="active === 'Categories'" label="Choose category">
              <v-select v-model="createForm.category_id" :options="categories" :reduce="(ct) => ct.id" label="name" />
            </b-form-group>

            <b-form-group v-else-if="active === 'Products'" label="Choose product">
              <v-select
                v-model="createForm.product_id"
                :options="products"
                :reduce="(product) => product.id"
                label="name"
              />
            </b-form-group>

            <b-button
              type="submit"
              variant="secondary"
              size="lg"
              :disabled="isLoading || componentLoading"
              :class="{
                'btn-multiple-state btn-shadow mt-2': true,
                'show-spinner': isLoading || componentLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label text-uppercase">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { handleArrayDataInternalization, getDateWithFormat } from '@/utils'
const { required, numeric } = require('vuelidate/lib/validators')

export default {
  components: { Datepicker },
  data: () => ({
    componentLoading: false,
    active: null,
    activeOptions: ['Categories', 'Products', 'None'],
    createForm: {
      name_en: '',
      name_ru: '',
      code: '',
      sale: '',
      start: new Date(),
      end: new Date(),
      category_id: '',
      product_id: ''
    }
  }),
  validations: {
    createForm: {
      name_en: { required },
      name_ru: { required },
      code: { required },
      sale: { required, numeric },
      start: { required },
      end: { required }
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['promocodes/isLoading']
    },
    categories() {
      const requirements = this.$store.getters['promocodes/requirements']
      return handleArrayDataInternalization(requirements.categories, ['name'], this.$i18n.locale)
    },
    products() {
      const requirements = this.$store.getters['promocodes/requirements']
      return handleArrayDataInternalization(requirements.products, ['name'], this.$i18n.locale)
    }
  },
  watch: {
    active() {
      this.createForm.category_id = ''
      this.createForm.product_id = ''
    }
  },
  mounted() {
    this.$store.dispatch('promocodes/fetchRequirements')
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          ...this.createForm,
          start: getDateWithFormat(this.createForm.start),
          end: getDateWithFormat(this.createForm.end)
        }

        this.$store.dispatch('promocodes/createPromocode', {
          payload,
          vm: this
        })
      }
    }
  }
}
</script>
